import { createSlice } from '@reduxjs/toolkit';
import { IFracnhises, TStatus } from 'shared/common/types/franchises';

const initialState: IFracnhises = {
  status: TStatus.Initial,
  data: [],
};

const franchisesSlice = createSlice({
  initialState,
  name: 'franchises',
  reducers: {},
});

export const { reducer: franchiseReducer } = franchisesSlice;
